import { View } from "extensions/marionette";

import emptySavedFiltersTemplate from "./emptySavedFilters.jst";

export const EmptySavedFilters = View.extend({
    className: "saved-filters-empty",
    template: emptySavedFiltersTemplate
});
